(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["soso-featured-shop"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initialize(root){
    root.querySelectorAll('.soso-swipe-controls').forEach(function(controls){
      if(controls.dataset.ready)return;
      var buttons=controls.querySelectorAll('button');
      var row=document.getElementById(buttons[0].getAttribute('aria-controls'));
      if(!row)return;
      controls.dataset.ready='true';
      function update(){
        var overflow=row.scrollWidth-row.clientWidth;
        var position=Math.abs(row.scrollLeft);
        controls.hidden=overflow<2;
        buttons[0].disabled=position<2;
        buttons[1].disabled=position>=overflow-2;
      }
      buttons.forEach(function(button){
        button.addEventListener('click',function(){
          var step=row.children[0].getBoundingClientRect().width+parseFloat(getComputedStyle(row).columnGap);
          var direction=getComputedStyle(row).direction==='rtl'?-1:1;
          row.scrollBy({left:step*Number(button.dataset.sosoScroll)*direction,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        });
      });
      row.addEventListener('scroll',update,{passive:true});
      new ResizeObserver(update).observe(row);
      update();
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load',function(event){initialize(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soso-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('soso-hero-video'))customElements.define('soso-hero-video',class extends HTMLElement{
 connectedCallback(){
  this.video=this.querySelector('video');
  this.preference=matchMedia('(prefers-reduced-motion: reduce)');
  this.onPreference=()=>{if(this.preference.matches)this.video.pause();else{this.video.muted=true;this.video.play().catch(()=>{});}};
  this.preference.addEventListener('change',this.onPreference);
  this.onPreference();
 }
 disconnectedCallback(){this.preference.removeEventListener('change',this.onPreference);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soso-newsletter-popup"]) return;
  try {
    
(()=>{
 const dialog=document.getElementById('SosoSignup');
 if(!dialog||typeof dialog.showModal!=='function'||window.Shopify?.designMode)return;
 const read=(key)=>{try{return localStorage.getItem(key)}catch{return null}};
 const save=(key,value)=>{try{localStorage.setItem(key,value)}catch{}};
 const subscribedKey='soso_newsletter_subscribed_v1',shownKey='soso_newsletter_shown_visit_v1';
 const shownThisVisit=()=>{try{return sessionStorage.getItem(shownKey)==='true'}catch{return false}};
 const rememberVisit=()=>{try{sessionStorage.setItem(shownKey,'true')}catch{}};
 const suppressed=()=>dialog.dataset.subscribed==='true'||read(subscribedKey)==='true'||shownThisVisit();
 let previousFocus,previousOverflow,timer;
 const open=()=>{if(dialog.open||document.querySelector('dialog[open]'))return;previousFocus=document.activeElement;previousOverflow=document.body.style.overflow;dialog.showModal();rememberVisit();document.body.style.overflow='hidden';dialog.querySelector('h2').focus({preventScroll:true})};
 const dismiss=()=>{dialog.close()};
 dialog.querySelectorAll('[data-signup-close]').forEach(button=>button.addEventListener('click',dismiss));
 dialog.addEventListener('cancel',event=>{event.preventDefault();dismiss()});
 dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dismiss()});
 dialog.addEventListener('close',()=>{document.body.style.overflow=previousOverflow??'';previousFocus?.focus?.({preventScroll:true})});
 if(dialog.querySelector('[data-signup-success]')){save(subscribedKey,'true');if(location.hash==='#SosoSignupForm')open();return}
 if(dialog.querySelector('[data-signup-error]')&&location.hash==='#SosoSignupForm'){open();return}
 if(suppressed())return;
 const showWhenReady=()=>{if(suppressed())return;if(document.hidden||document.activeElement?.matches('input,textarea,select')||document.querySelector('dialog[open]')){timer=setTimeout(showWhenReady,2000);return}open()};
 timer=setTimeout(showWhenReady,Number(dialog.dataset.delay)*1000);
 window.addEventListener('pagehide',()=>clearTimeout(timer),{once:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soso-prints"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e){const open=e.target.closest('[data-open-print]');if(open){document.getElementById(open.dataset.openPrint)?.showModal();}const close=e.target.closest('[data-close-print]');if(close){close.closest('dialog').close();}if(e.target.tagName==='DIALOG'){const r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close();}});

if(!customElements.get('soso-scroll-art'))customElements.define('soso-scroll-art',class extends HTMLElement{
 connectedCallback(){
  this.motion=matchMedia('(prefers-reduced-motion: reduce)');
  this.frame=0;
  this.draw=()=>{
   this.frame=0;
   if(this.motion.matches){this.style.removeProperty('transform');return;}
   const rect=this.getBoundingClientRect();
   const center=rect.top+rect.height/2;
   const offset=(innerHeight/2-center)/Math.max(1,innerHeight/2);
   const angle=Math.max(-50,Math.min(50,offset*50));
   this.style.transform='rotate('+angle.toFixed(2)+'deg)';
  };
  this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(this.draw);};
  this.onPreference=()=>{this.schedule();};
  addEventListener('scroll',this.schedule,{passive:true});
  addEventListener('resize',this.schedule,{passive:true});
  this.motion.addEventListener('change',this.onPreference);
  this.schedule();
 }
 disconnectedCallback(){
  removeEventListener('scroll',this.schedule);
  removeEventListener('resize',this.schedule);
  this.motion.removeEventListener('change',this.onPreference);
  cancelAnimationFrame(this.frame);
 }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soso-product"]) return;
  try {
    
if(!customElements.get('soso-gallery'))customElements.define('soso-gallery',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.track=this.querySelector('.gallery-track');this.slides=[...this.querySelectorAll('.gallery-slide')];this.index=0;
this.querySelectorAll('[data-gallery-step]').forEach(b=>b.addEventListener('click',()=>this.go(this.index+Number(b.dataset.galleryStep))));
this.track.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)||e.target!==this.track)return;e.preventDefault();this.go(e.key==='Home'?0:e.key==='End'?this.slides.length-1:this.index+(e.key==='ArrowRight'?1:-1));});
this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>{const left=this.track.getBoundingClientRect().left;this.index=this.slides.reduce((best,s,i)=>Math.abs(s.getBoundingClientRect().left-left)<Math.abs(this.slides[best].getBoundingClientRect().left-left)?i:best,0);this.update();});},{passive:true});
this.showMedia(this.dataset.start,false);this.update();}
go(i,smooth=true){this.index=Math.max(0,Math.min(i,this.slides.length-1));const slide=this.slides[this.index];if(!slide)return;this.track.scrollTo({left:slide.offsetLeft-this.slides[0].offsetLeft,behavior:smooth&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'});this.update();}
showMedia(id,smooth=true){const i=this.slides.findIndex(s=>s.dataset.mediaId===id);if(i>=0)this.go(i,smooth);}
update(){const c=this.querySelector('[data-gallery-count]');if(c)c.textContent=(this.index+1)+' / '+this.slides.length;this.querySelectorAll('[data-gallery-step]').forEach(b=>b.disabled=Number(b.dataset.galleryStep)<0?this.index===0:this.index===this.slides.length-1);}
});
document.addEventListener('change',function(e){if(!e.target.matches('[data-variant-select]'))return;const s=e.target,o=s.selectedOptions[0];const price=document.getElementById(s.dataset.priceTarget);if(price){const cents=Number(o.dataset.priceCents);const money=price.querySelectorAll('[data-soso-money]');if(Number.isFinite(cents)&&money.length){money.forEach(node=>{const amount=Math.round(cents*Number(node.dataset.sosoMultiplier||100)/100);node.dataset.sosoMoney=String(amount);if(window.SosoCurrency){window.SosoCurrency.refresh(node);}else{node.textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:node.dataset.sosoBase||'QAR',currencyDisplay:'code'}).format(amount/100);}});}else if(o.dataset.price){price.textContent=o.dataset.price;}}s.closest('.product-layout').querySelector('soso-gallery')?.showMedia(o.dataset.mediaId);const b=document.getElementById(s.dataset.buttonTarget);if(b){b.disabled=o.dataset.available!=='true';b.textContent=b.disabled?b.dataset.sold:b.dataset.add;}const u=new URL(location.href);u.searchParams.set('variant',s.value);history.replaceState({},'',u);});

  } catch(e) { console.error(e); }
})();
})();
